/** @class {Action} */
import Action from '../flux/Action';

/** @type {Action} */
export default new Action({
  // HOVER TOOLTIP ACTIONS
  HOVER_ENTER: 20,
  HOVER_LEAVE: 21
});



// WEBPACK FOOTER //
// ./frontend/react/sim/core/actions/tooltip.js